import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-management-pop-up',
  templateUrl: './product-management-pop-up.component.html',
  styleUrls: ['./product-management-pop-up.component.scss']
})
export class ProductManagementPopUpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
